import React from 'react';
import Aside from '../../components/UI/Aside/aside';
import ChatComponent from './chatComponents/chatComponent';
import './chat.css';
const Chat = () => {
  return (
    <div className="Chat">
      <Aside floor={false} />
      <ChatComponent></ChatComponent>
    </div>
  );
};

export default Chat;
